import { format } from 'date-fns';

import { encryptData } from './encryption';

export async function generateSessionId(caller_id) {
  const timestamp_delta = sessionStorage.getItem('current_timestamp_delta');

  if (timestamp_delta !== null) {
    const timestamp = format(new Date(Date.now() + Number(timestamp_delta)), 'dd/MM/yyyy HH:mm:ss');

    console.log('timestamp: ', timestamp);
    const sessionId = `caller_id#${caller_id}#timestamp#${timestamp}`;

    return await encryptData(sessionId, process.env.RSA_SESSION_PUBLIC_KEY);
  }

  return null;
}
